import './PermissionsTag.scss';

import classNames from 'classnames';
import React from 'react';

import { Col, Space, Tooltip } from 'antd';
import { FieldPermission, ObjectPermission } from '@sonar-software/sonar-core';

export type PermissionsTagProps = {
	className?: string;
    direction?: 'horizontal' | 'vertical';
    noncongruent?: Array<string>;
    permissions: Record<string, string>;
    permissionsType?: 'object' | 'field';
};

export const objectPermissionLabels: Record<ObjectPermission, string> = {
	[ ObjectPermission.create ]: 'C',
	[ ObjectPermission.read ]: 'R',
	[ ObjectPermission.edit ]: 'E',
	[ ObjectPermission.delete ]: 'D',
	[ ObjectPermission.viewAllData ]: 'V',
	[ ObjectPermission.modifyAllData ]: 'M'
};

export const fieldPermissionLabels: Record<FieldPermission, string> = {
	[ FieldPermission.read ]: 'R',
	[ FieldPermission.edit ]: 'E'
};

export const PermissionsTag: React.FC<PermissionsTagProps> = ({
	className,
	direction,
	noncongruent = [],
	permissions,
	permissionsType = 'object'
}) => {
	const permissionLabels = permissionsType === 'object' ? objectPermissionLabels : fieldPermissionLabels;

	return (
		<Space
			className={ classNames('permissions-tags', className) }
			classNames={ { item: 'permission-row' } }
			direction={ direction ?? 'horizontal' }
			size={ 4 }>
			{
				Object.entries(permissionLabels).map(
					([ key ]) =>
						<Col
							className={ classNames('permission-row', {
								highlight: noncongruent.includes(key)
							}) }
							key={ key }>
							<div
								className={ classNames('permission-tag', {
									hasLabel: permissions[ key ] !== undefined && permissions[ key ] !== '',
									hasPermission: permissions[ key ] !== undefined
								}) }>
								<Tooltip title={ permissions[ key ] ?? '' }>
									{ permissionsType === 'object' ?
										objectPermissionLabels[ key as ObjectPermission ] :
										fieldPermissionLabels[ key as FieldPermission ] }
								</Tooltip>
							</div>
						</Col>
				)
			}
		</Space>);
};
